import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "infoboard"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  id: "sharpBlur",
  "color-interpolation-filters": "sRGB"
}
const _hoisted_4 = ["stdDeviation"]
const _hoisted_5 = ["values"]
const _hoisted_6 = {
  key: 0,
  class: "infoboard__grid"
}
const _hoisted_7 = { class: "infoboard__grid__element infoboard__grid__element--company" }
const _hoisted_8 = { class: "infoboard__grid__element infoboard__grid__element--chart" }
const _hoisted_9 = {
  key: 1,
  class: "infoboard__error"
}
const _hoisted_10 = {
  key: 2,
  class: "infoboard__error"
}
const _hoisted_11 = {
  key: 3,
  class: "infoboard__dots"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "infoboard__grid__element infoboard__grid__element--percentage" }
const _hoisted_14 = {
  key: 1,
  class: "g-window g-window--border-only"
}
const _hoisted_15 = { class: "g-text g-text--center g-text--l" }
const _hoisted_16 = { class: "infoboard__logo" }
const _hoisted_17 = {
  key: 1,
  class: "g-window g-window--border-only g-text g-text--l g-text--center"
}
const _hoisted_18 = { class: "fa-stack fa-2x" }
const _hoisted_19 = { class: "g-container g-text g-text--xs g-text--center" }
const _hoisted_20 = {
  key: 1,
  class: "infoboard infoboard--error"
}
const _hoisted_21 = { class: "g-window g-window--border-only g-text g-text--l g-text--center" }
const _hoisted_22 = { class: "g-container" }
const _hoisted_23 = { class: "g-text g-text--xs g-text--center" }
const _hoisted_24 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoboardCompany = _resolveComponent("InfoboardCompany")!
  const _component_InfoboardChart = _resolveComponent("InfoboardChart")!
  const _component_StackedIconInformation = _resolveComponent("StackedIconInformation")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_InfoboardDescription = _resolveComponent("InfoboardDescription")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!(_ctx.error || _ctx.computedNoNetwork))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "infoboard__background",
            style: _normalizeStyle(_ctx.computedBackgroundStyle)
          }, [
            (_ctx.infoboard.greyscale !== undefined && _ctx.infoboard.backgroundBlurFactor !== undefined && _ctx.computedSupportsFilter)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [
                  _createElementVNode("filter", _hoisted_3, [
                    _createElementVNode("feGaussianBlur", {
                      stdDeviation: _ctx.infoboard.backgroundBlurFactor
                    }, null, 8, _hoisted_4),
                    _cache[1] || (_cache[1] = _createElementVNode("feColorMatrix", {
                      type: "matrix",
                      values: "1 0 0 0 0, 0 1 0 0 0, 0 0 1 0 0, 0 0 0 9 0"
                    }, null, -1)),
                    _createElementVNode("feColorMatrix", {
                      type: "saturate",
                      values: String(1 - _ctx.infoboard.greyscale / 100)
                    }, null, 8, _hoisted_5)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 4),
          (!_ctx.infoboard.disabled)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.computedCurrentRotation)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_InfoboardCompany, {
                          type: _ctx.computedType,
                          "rotation-name": _ctx.computedCurrentRotationObject?.title || '',
                          "text-field": _ctx.computedCurrentRotationObject?.textField || '',
                          "rotation-type": _ctx.computedCurrentRotationObject?.rotationType || 'single',
                          logo: _ctx.infoboard.companyLogo
                        }, null, 8, ["type", "rotation-name", "text-field", "rotation-type", "logo"])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_InfoboardChart, {
                          class: _normalizeClass({'hide-chart': !_ctx.computedChartHasData}),
                          rotation: _ctx.computedCurrentRotation,
                          locale: _ctx.infoboard.locale
                        }, null, 8, ["class", "rotation", "locale"]),
                        (!_ctx.computedChartHasData)
                          ? (_openBlock(), _createBlock(_component_StackedIconInformation, {
                              key: 0,
                              class: "g-text g-text--l g-text--center no-data",
                              icon: ['fal', 'chart-bar']
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('sharedTexts.noData')), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.computedOldData)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createVNode(_component_FontAwesomeIcon, { icon: ['fal', 'exclamation-triangle'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('sharedTexts.networkError')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.computedTimezoneWarning)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createVNode(_component_FontAwesomeIcon, { icon: ['fal', 'exclamation-triangle'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('sharedTexts.timezoneWarning')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.rotations.length > 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rotations.length, (count) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: count,
                                  onClick: _withModifiers(($event: any) => (_ctx.setInfoboardCount(count - 1)), ["stop"])
                                }, [
                                  _createVNode(_component_FontAwesomeIcon, {
                                    icon: ['fad', 'circle'],
                                    style: _normalizeStyle({'--fa-secondary-opacity': count - 1 === _ctx.currentRotationIndex ? 0.5 : 0})
                                  }, null, 8, ["style"])
                                ], 8, _hoisted_12))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        (_ctx.computedCurrentRotation.description && _ctx.computedChartHasData)
                          ? (_openBlock(), _createBlock(_component_InfoboardDescription, {
                              key: 0,
                              rotation: _ctx.computedCurrentRotation,
                              locale: _ctx.infoboard.locale
                            }, null, 8, ["rotation", "locale"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_FontAwesomeIcon, {
                          class: "fa-spin",
                          icon: ['fad', 'spinner-third']
                        })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('sharedTexts.loading')), 1)
                    ])),
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('sharedTexts.poweredBy')), 1)
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, [
                  _createVNode(_component_StackedIconInformation, { icon: ['fad', 'plug'] })
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('sharedTexts.disabled')), 1)
                ])
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_StackedIconInformation, {
              icon: _ctx.computedError.icon
            }, null, 8, ["icon"]),
            _createElementVNode("div", null, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.$t('sharedTexts.error')), 1),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.computedError.text), 1)
              ])
            ])
          ])
        ])),
    _createElementVNode("button", {
      class: "sign-out",
      title: _ctx.$t('sharedTexts.logout'),
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.signOutClicked && _ctx.signOutClicked(...args)), ["stop"]))
    }, [
      _createVNode(_component_FontAwesomeIcon, { icon: ['fal', 'sign-out-alt'] })
    ], 8, _hoisted_24)
  ], 64))
}